import { useTranslation } from 'react-i18next';

export default function ContactHero() {
  const { t } = useTranslation();

  return (
    <section className="relative pt-32 pb-20 overflow-hidden bg-gradient-to-br from-[#1a1a2e] via-[#16213e] to-[#0f3460]">
      {/* Animated Background */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-20 left-10 w-72 h-72 bg-[#FF6B6B]/20 rounded-full blur-3xl animate-pulse"></div>
        <div
          className="absolute bottom-10 right-10 w-96 h-96 bg-[#4ECDC4]/15 rounded-full blur-3xl animate-pulse"
          style={{ animationDelay: "1s" }}
        ></div>
      </div>

      {/* Geometric Elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-32 right-20 w-4 h-4 bg-[#FF6B6B] rounded-full opacity-60"></div>
        <div className="absolute top-48 right-40 w-2 h-2 bg-[#4ECDC4] rounded-full opacity-60"></div>
        <div className="absolute bottom-20 left-20 w-3 h-3 bg-[#FF8E53] rounded-full opacity-60"></div>
        <div className="absolute top-1/3 left-16 w-20 h-20 border border-white/10 rounded-2xl rotate-12"></div>
        <div className="absolute bottom-1/4 right-24 w-16 h-16 border border-[#FF6B6B]/20 rounded-full"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 text-center">
        <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/10 backdrop-blur-sm rounded-full mb-8">
          <span className="w-2 h-2 bg-[#4ECDC4] rounded-full animate-pulse"></span>
          <span
            className="text-white/80 text-sm font-medium"
            style={{ fontFamily: "Poppins, sans-serif" }}
          >
            {t('contactPage.heroBadge')}
          </span>
        </div>

        <h1
          className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight"
          style={{ fontFamily: "Poppins, sans-serif" }}
        >
          {t('contactPage.heroTitle')}
          <br />
          <span className="bg-gradient-to-r from-[#FF6B6B] via-[#FF8E53] to-[#4ECDC4] bg-clip-text text-transparent">
            {t('contactPage.heroTitleHighlight')}
          </span>
        </h1>

        <p
          className="text-lg text-white/60 max-w-2xl mx-auto leading-relaxed"
          style={{ fontFamily: "Poppins, sans-serif" }}
        >
          {t('contactPage.heroDesc')}
        </p>
      </div>

      {/* Bottom Wave */}
      <div className="absolute bottom-0 left-0 right-0">
        <svg
          viewBox="0 0 1440 80"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0 80L60 73C120 66 240 53 360 46C480 40 600 40 720 43C840 46 960 53 1080 56C1200 60 1320 60 1380 60L1440 60V80H1380C1320 80 1200 80 1080 80C960 80 840 80 720 80C600 80 480 80 360 80C240 80 120 80 60 80H0Z"
            fill="white"
          />
        </svg>
      </div>
    </section>
  );
}
